/**
 * Discount Filter - Ottimizzato per performance
 */

// Usa requestIdleCallback per non bloccare il main thread
const scheduleTask = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

document.addEventListener('DOMContentLoaded', function() {
  scheduleTask(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const discountParam = urlParams.get('discount');
    
    // Applica filtro se presente nell'URL
    if (discountParam) {
      filterProducts(discountParam);
      highlightActiveButton(discountParam);
    } else {
      // Nessun filtro: evidenzia "Tutti"
      highlightActiveButton('');
    }
    
    // Click handler con event delegation per performance
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-range]');
      if (!btn) return;
      
      e.preventDefault();
      const range = btn.dataset.range;
      
      if (range === '') {
        // Click su "Tutti": mostra tutti i prodotti
        const items = document.querySelectorAll('.product-grid__item');
        for (let i = 0; i < items.length; i++) {
          items[i].style.display = '';
        }
        highlightActiveButton('');
        
        // Rimuovi parametro discount dall'URL
        const url = new URL(window.location);
        url.searchParams.delete('discount');
        history.replaceState({}, '', url);
      } else {
        filterProducts(range);
        highlightActiveButton(range);
        
        // Aggiorna URL
        const url = new URL(window.location);
        url.searchParams.set('discount', range);
        history.replaceState({}, '', url);
      }
    });
  });
});

function filterProducts(range) {
  const [min, max] = range.split('-').map(Number);
  const productItems = document.querySelectorAll('.product-grid__item');
  
  // Usa DocumentFragment per batch DOM updates
  requestAnimationFrame(() => {
    for (let i = 0; i < productItems.length; i++) {
      const item = productItems[i];
      const price = item.querySelector('.price');
      const comparePrice = item.querySelector('.compare-at-price');
      
      if (!price || !comparePrice) {
        item.style.display = 'none';
        continue;
      }
      
      const p = parseFloat(price.textContent.replace(/[^0-9.,]/g, '').replace(',', '.'));
      const cp = parseFloat(comparePrice.textContent.replace(/[^0-9.,]/g, '').replace(',', '.'));
      
      if (cp > p) {
        const disc = Math.round(((cp - p) / cp) * 100);
        // Usa <= invece di < per includere il valore massimo
        item.style.display = (disc >= min && disc <= max) ? '' : 'none';
      } else {
        item.style.display = 'none';
      }
    }
  });
}

function highlightActiveButton(range) {
  requestAnimationFrame(() => {
    const buttons = document.querySelectorAll('.discount-btn, .discount-btn-desk');
    for (let i = 0; i < buttons.length; i++) {
      const btn = buttons[i];
      if (btn.dataset.range === range) {
        btn.style.cssText = 'background: #000000; color: #FFFFFF; font-weight: 700;';
      } else {
        btn.style.cssText = 'background: #F2F2F2; color: #000000; font-weight: 500;';
      }
    }
  });
}
